import { render, staticRenderFns } from "./FeatureController.vue?vue&type=template&id=ac4d02a4&scoped=true&"
import script from "./FeatureController.vue?vue&type=script&lang=js&"
export * from "./FeatureController.vue?vue&type=script&lang=js&"
import style0 from "./FeatureController.vue?vue&type=style&index=0&id=ac4d02a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4d02a4",
  null
  
)

export default component.exports